import { Approver, JustificationNote } from 'components/WizardTypes/Wizard.types';

export type TAddRequestAttachments = {
  requestId: number;
  data: any;
};

export type RequestTimelineData = {
  requestId: number;
  requestedImplementationDate: string;
  dueDateReason: string;
  ridStateRed: boolean;
  ridStateAmber: boolean;
  escalation?: {
    escalationRequested: boolean;
    escalationApproved: boolean;
    escalationJustification: string;
    escalationApproverTeamId: number;
    escalationApproverName: string;
    escalationRowVersion: string;
  };
  rowVersion: string;
};

export type UpdateRequestTimeline = {
  requestId: number;
  requestedImplementationDate?: string;
  dueDateReason?: string;
  escalation?: {
    escalationApproved?: boolean;
    escalationJustification?: string;
    escalationApproverTeamId?: number;
    escalationRowVersion?: string;
  };
  rowVersion: string;
};

export type AddFDRequestPayload = {
  departmentId: number;
  teamId: number;
  supervisorTeamId: number;
  projectName: string;
  projectPurposeId: number;
  projectPurposeOtherText: string;
  projectTypeId: number;
  updateNotes: string;
  dueDateReason: string;
  intendedUse: string;
  escalationJustification: string;
  escalationApproverTeamId: number;
  draftId: number;
  requestedImplementationDate: string | Date;
  businessImpactId: number;
  justificationNotes: JustificationNote[];
  approvers: Approver[];
};

export type BuildingData = {
  buildings: Array<Building>;
};

export type Building = {
  id: number;
  displayValue: string;
  fdBuildingId: number;
  buildingShortName: string;
  buildingLongName: string;
  groupRoutingId: number;
  groupRoutingTypeId: number;
  groupRoutingName: string;
  orderBy: number;
};

export type AddFDRBuildingPayload = {
  requestId: number;
  fdBuildingId: number;
  floor: string;
  area: string;
  locationText: string;
};

export type GetBuilding = {
  fdDetailBuildingMappingId: number;
  fdRequestDetailId: number;
  fdBuildingId: number;
  floor: string;
  area: string;
  locationText: string;
  rowVersion: string;
};

export type UpdateFDRBuildingPayload = {
  requestId: number;
  fdDetailBuildingMappingId: number;
  fdBuildingId: number;
  floor: string;
  area: string;
  locationText: string;
  rowVersion: string;
};

export type CreateOrResubmitCWRequestPayload = {
  departmentId: number;
  teamId: number;
  supervisorTeamId: number;
  secondaryContactId: number;
  projectName: string;
  projectPurposeId: number;
  projectPurposeOtherText: string;
  projectTypeId: number;
  updateNotes: string;
  dueDateReason: string;
  intendedUse: string;
  escalationJustification: string;
  escalationApproverTeamId: number;
  draftId?: number;
  requestId?: number;
  requestedImplementationDate: Date | null;
  businessImpactId: number;
  justificationNotes: {
    justificationNoteTypeId: number;
    noteText: string;
  }[];
  corporateWebsiteDetail?: {
    brochureOrVideoUpdate: boolean;
    webpages: {
      name: string;
      url: string;
      rowVersion?: string;
      cwWebpageId?: number;
    }[];
    rowVersion?: string;
  };
  requestedRegions: string;
  approvers: {
    sequence: number;
    reviewerId: number;
  }[];
  rowVersion?: string;
};

export type Webpage = {
  cwWebpageId: number;
  cwRequestDetailId: number;
  name: string;
  url: string;
  rowVersion: string;
};

export type CWDetails = {
  cwRequestDetailId: number;
  requestId: number;
  brochureOrVideoUpdate: boolean;
  webpages: Webpage[];
  hasWebpageSection: boolean;
  hasMediaUpdateSection: boolean;
  hasUpdateTypeSection: boolean;
  deleted: boolean;
  rowVersion: string;
};

export type CWWebpage = {
  cwWebpageId: number;
  cwRequestDetailId: number;
  name: string;
  url: string;
  rowVersion: string;
};

export type AddOrEditCWWebpagePayload = {
  requestId: number;
  name: string;
  url: string;
  cwWebpageId?: number;
  rowVersion?: string;
};

export type DeleteCWWebPagePayload = {
  cwWebpageId: number;
  requestId: number;
  rowVersion: string;
};

export type CWMediaSection = {
  cwRequestDetailId: number;
  requestId: number;
  brochureOrVideoUpdate: boolean;
  cwRequestDetailRowVersion: string;
};

export type AtsDetailCategory = {
  id: number;
  displayValue: string;
  name: string;
  description: string;
  orderBy: number;
};

export type AtsDetailCategories = {
  requestCategories: AtsDetailCategory[];
};

export enum RequestViewId {
  MyDashboard = 1,
  Requests = 2,
  Backlog = 3,
  InProcess = 4,
  Tasks = 5,
  Triage = 6,
  Drafts = 7,
  Programs = 8,
  ProgramRequests = 9,
  AssignedRequests = 10,
  TDInProcess = 11,
  TDInQueue = 12,
  TDOnHold = 13,
  TDCompleted = 14
}

export type RequestView = {
  id: RequestViewId;
  displayValue: string;
  name: string;
  description: string;
  orderBy: number;
};

export type UpdateCategories = {
  restrictedCostCenterNumbers: [];
  id: number;
  displayValue: string;
  name: string;
  orderBy: number;
  description: string;
};

export type RequestUpdateCategories = {
  otherCategories: UpdateCategories[];
  recentCategories: UpdateCategories[];
};
